/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(function($) {
    $(document).ready(function() {

        const modal = $('#catalogModal'),
              navCatalogMobile = $('.nav-catalog-mobile'),
              indexCatalogPag = $('.pag_num', modal),
              indexNavCatalog = $('.pag_num', navCatalogMobile),
              btnZoom = $('#btnDisplayCatalog'),
              [...section_catalog] = $('.section-catalog', modal);
              navCatalogPag = $('.content--header__nav'),
              btnNextCatalogPag = $('.catalog-nav__next'),
              btnPrevCatalogPag = $('.catalog-nav__prev'),
              btnNextNav = $('.flickity-prev-next-button.next'),
              btnPrevNav = $('.flickity-prev-next-button.prev')

        const contPages = document.querySelector('.catalog-list .flickity-slider');
        if(contPages) {
            const elemPage = contPages.lastChild;

            const observerPageCatalogo = new IntersectionObserver(hideNextBtn, {
                threshold: 0.1
            });        

            observerPageCatalogo.observe(elemPage)
        }

        appendBtns();

        $(window).resize(function () { 
            appendBtns();
            updateIndexTxt();
        });

        //flkty.on( 'select', updateStatus );

        $(document).click(function (evt) {
            if ( evt.target.classList.contains('catalog__btn-buy')) {
                evt.preventDefault();
                evt.stopPropagation();
                let self = evt.target;
                let varId = self.getAttribute('data-product-id');
                if(varId == null || varId == '') {
                    return;
                }             
                addToCart(1, varId, self);    
            }
        });

        $(window).click(function(e) {
            if (e.target == modal[0]) {
                $(modal).css('display', 'none');
            }            
        });

        $(btnZoom).click(function(e) {  
            e.preventDefault();
            $(modal).css('display', 'block');
            $(indexCatalogPag).text(1);
            addRemoveClassActive(1);
        });

        $(window).on('touchend', updateIndexTxt );
        $(btnNextNav).on('click', updateIndexTxt );
        $(btnPrevNav).on('click', updateIndexTxt );

        $('.quick-links__link').each(function (indexInArray, valueOfElement) {             
            let $index = $(this).attr('data-index');
            $(this).click(function () {
                $(modal).css('display', 'block');
                $(navCatalogPag).attr('data-current-page', $index);
                $(indexCatalogPag).text($index);
                addRemoveClassActive($index);
            });
        });
        $(btnPrevCatalogPag).click(function (e) {  
            //e.preventDefault();
            let current_value = $(navCatalogPag).attr('data-current-page');
            if(current_value != 1) {
                current_value--;
                $(navCatalogPag).attr('data-current-page', current_value);
                $(indexCatalogPag).text(current_value);
                addRemoveClassActive(current_value)
            } else {
                console.log('valor min')
            }
        });
        $(btnNextCatalogPag).click(function (e) {
            //e.preventDefault();
            let current_value = $(navCatalogPag).attr('data-current-page');
            let pages_size = $(navCatalogPag).attr('data-pages-size');
            if(current_value != pages_size) {
                current_value++;
                $(navCatalogPag).attr('data-current-page', current_value);
                $(indexCatalogPag).text(current_value);
                addRemoveClassActive(current_value)
            } else {
                console.log('valor max')
            }
        });

        // Select in mobile catalog navigation
        $("#slcNavigationCatalogMobile").click(function() {
            var open = $(this).data("isopen");
            if(open) {
              //window.location.href = $(this).val()
            }
            //set isopen to opposite so next time when use clicked select box
            //it wont trigger this event
            $(this).data("isopen", !open);
          });

        $('.modal-catalog__close',modal).click(function(e) {  
            e.preventDefault();
            $(modal).css('display', 'none');
        });

        $('a[data-toggle="tab"]').on('click touched', function (e) {
            e. preventDefault()

            $('.tab-pane').removeClass('active show')
            $('#'+ $(this).attr('aria-controls') + '.tab-pane').addClass('active show')
        })

        $('.card-link').on('click touched', function (e) {
            e. preventDefault()

            if ($(this).hasClass('collapsed')) {
                $(this).removeClass('collapsed')
            } else {
                $(this).addClass('collapsed')
            }

            if ($($(this).attr('data-collapse') + '.collapse').hasClass('active show')) {
                $($(this).attr('data-collapse') + '.collapse').removeClass('active show')
            } else {
                $($(this).attr('data-collapse') + '.collapse').addClass('active show')
            }
        });

        
        document.addEventListener('product:added', function() {
            $(modal).css('display', 'none');
        })
        

        function addRemoveClassActive(index) {
            /*
            for(let i = 0; i < section_catalog.length; i++) {
                if ((i+1) == index) {
                    $(section_catalog[i]).addClass('active');
                } else {
                    $(section_catalog[i]).removeClass('active');
                }
            }
            */
            section_catalog.forEach((element, i) => {
                if ((i+1) == index) {
                    $(element).addClass('active');
                } else {
                    $(element).removeClass('active');
                }
            });
            // Fill empty items in the grid
            let [...toFillModal] = $('.to-fill',section_catalog[index-1]);
            let gridCatalogItem = $('.grid-catalog__item',section_catalog[index-1])[0];
            let defaultHeight = 375;
            let height = ($(gridCatalogItem).height()) > 0 ? $(gridCatalogItem).height() : defaultHeight; // Assign a default value in case that there aren't any grid item
            if(innerWidth < 768) {
                $(toFillModal).parent().css('display','none');
            } else {
                if(height != null) { 
                    $(toFillModal).each(e => {        
                        $(toFillModal[e]).css('height', height);
                        $(toFillModal[e]).parent().css('display','flex');
                    })
                }
            }
        }

        // Take flickity buttons and change its place in mobile 
        function appendBtns() {
            let contOrigin = $('.flickity-enabled')[0];
            //let contOriginMobile = $('.nav-catalog-mobile');
            let contDestPrev = $('#btnPrev');
            let contDestNext = $('#btnNext');
            let btnPrev = $('.flickity-button.flickity-prev-next-button.previous');
            let btnNext = $('.flickity-button.flickity-prev-next-button.next');
            //let lc = $(contOrigin).find('.flickity-button').length;
            
            // Use detach because remove() misses the event associated with the element
            if(window.innerWidth < 768) {
                btnPrev = $(btnPrev).detach(); // detach() return the element detached
                btnNext = $(btnNext).detach();                
                $(contDestPrev).prepend(btnPrev);
                $(contDestNext).append(btnNext);
            } else {            
                btnPrev = $(btnPrev).detach(); 
                btnNext = $(btnNext).detach();
                $(contOrigin).append(btnPrev);
                $(contOrigin).append(btnNext);
            }        
        }

        function updateIndexTxt() {
            setTimeout(function () {
                let slideSelected = $('.quick-links__link.is-selected');
                let index = $(slideSelected).attr('data-index');            
                $(indexNavCatalog).text(index)
            }, 250);
        }

        async function addToCart( qty, varId, btn ) {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: varId, quantity: qty })
            })            
            .then( res => {
                //res.json();
                if(res.ok) {
                    document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                        bubbles: true,
                        detail: {
                            quantity: qty
                        }
                    }));
                }
            })
            // Open a new cart window after of add  a product
            /*            
            .then( () => window.open('/cart'))
            */         
            .catch( err => console.error(err))
            
        }

        // Observer callback
        function hideNextBtn(entries, observer) {
            const btnNextNav = document.querySelector('.flickity-button.flickity-prev-next-button.next');
            if(btnNextNav) {
                const entry = entries[0];
                if(entry.isIntersecting) {
                    btnNextNav.style.display = "none";
                } else {
                    btnNextNav.style.display = "inline-flex";
                }
            }
        }
    })
});